import { z } from 'zod';
import {
  emailValidation,
  nameValidation,
  phoneValidation,
} from '../../validation';

export const ReferralPatientSchema = z.object({
  firstname: nameValidation('Patient first name is required'),
  lastname: nameValidation('Patient surname is required'),
  email: emailValidation('Patient email is required'),
  phone: phoneValidation().optional(),
  // Patient identifier assigned by the referring organization,
  // unique within that organization
  externalId: z.string().trim().optional(),
  // The patient's insurance plan identifiers — their standard home across
  // every organization (PPL-3600): the policy the patient is covered by and
  // the claim opened under it for this referral. Legacy bodies still send
  // `claimNumber` at the referral's top level; the create schemas hoist it
  // here (see hoistPlanIdentifiersToPatient).
  policyNumber: z.string().trim().optional(),
  claimNumber: z.string().trim().optional(),
});

export type ReferralPatient = z.infer<typeof ReferralPatientSchema>;
